import ManagementSearch from "src/components/pages/Management/ManagementSearch/ManagementSearch";
import ManagementTable from "src/components/pages/Management/ManagementTable/ManagementTable";
import useGetAllYachts from "src/components/pages/Management/Yachts/useGetAllYachts";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { ButtonWrapper } from "src/pages/Settings/AccountDetails/AccountDetails.styled";
import { PageContainer } from "src/styled";

const FleetYachts = () => {
  const { yachts, isLoading } = useGetAllYachts();

  return (
    <PageContainer>
      <Breadcrumbs border={false}>
        <ButtonWrapper>
          <ManagementSearch
            section={"_fleet_yachts"}
            refetch={() => {}}
            currentRequestParams={{}}
          />
        </ButtonWrapper>
      </Breadcrumbs>

      <ManagementTable
        data={yachts}
        loading={isLoading}
        section="_fleet_yachts"
      />
    </PageContainer>
  );
};
export default FleetYachts;
